<template>
  <div>
    <form class="action-buttons-fixed" @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-user"></i>
                  <h2 class="card-big-info-title">Uloge</h2>
                  <p class="card-big-info-desc">Definirajte uloge korisnika.</p>
                </div>
                  <div class="col-lg-3-5 col-xl-4-5">
                    <div class="form-group row align-items-center mb-3">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Naziv uloge
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <input
                          type="text"
                          class="form-control form-control-modern"
                          v-model="role.name"
                        />
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Opis
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <textarea class="form-control" rows="3" v-model="role.description"></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Dozvoljene ekstenzije
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <treeselect
                          v-model="role.allowedDocumentExtensionIds"
                          :multiple="true"
                          :options="allowedDocumentExtensions"
                          placeholder="Izaberite dozvoljene ekstenzije"
                        />
                      </div>
                    </div>

                    <div class="form-group row align-items-center pb-3">
                      <label
                        class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >
                        Vidi zaštićene dokumenate?
                      </label>
                      <div class="col-lg-7 col-xl-6">
                        <div class="checkbox-custom checkbox-default">
                          <input
                            type="checkbox"
                            v-model="role.canSeeProtectedFiles"
                            id="can-see-protected-files"
                          />
                          <label for="can-see-protected-files"></label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row role">
                      <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                        Dozvole
                      </label>
                      <div class="col-lg-7 col-xl-8">
                        <!-- <treeselect
                          v-model="role.permissions"
                          :multiple="true"
                          :options="permissions"
                          @select="handleChangePermissions"
                          placeholder="Izaberite korisničke permisije"
                        /> -->
                        <div class="permissions-wrapper">
                          <div class="checkbox-custom checkbox-default checkbox-permission all-permissions">
                            <input
                              @click="checkAllPermissions"
                              type="checkbox"
                              id="all-permissions"
                              :checked="isAllPermissionsChecked"
                            />
                            <label for="all-permissions">Označi sve</label>
                          </div>

                          <div
                            class="checkbox-custom checkbox-default checkbox-permission"
                            v-for="item in permissions"
                            :key="item.id"
                          >
                            <input
                              type="checkbox"
                              :id="`checkbox-${item.id}`"
                              :value="item.id"
                              v-model="role.permissions"
                            />
                            <label :for="`checkbox-${item.id}`">{{ item.label }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div
        class="action-buttons d-flex justify-content-between"
      >
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="
              delete-button
              btn btn-danger btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
          >
            <i class="bx bx-trash text-4 me-2"></i> Izbriši
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            :to="{ name: 'UserRoles' }"
            exact
            class="
              cancel-button
              btn btn-light btn-px-4
              py-3
              border
              font-weight-semibold
              text-color-dark text-3
            "
          >
            Otkaži
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
          >
            <i class="bx bx-save text-4 me-2"></i> Sačuvaj
          </button>
        </div>
      </div>
    </form>

    <modal id="delete-modal">
        <h5 slot="header">
          <strong>Izbriši korisničku ulogu</strong>
        </h5>
        <div slot="body">
          <span v-html="roleModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteRole"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
  </div>
</template>

<script>
import Vue from 'vue';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import api from '@/services/api';
import { translations } from "@/mixins";
import Modal from "@/components/shared/modal/Modal.vue";

export default {
  name: 'EditUserRole',
  components: {
    Treeselect,
    Modal,
  },
  mixins: [translations],
  data() {
    return {
      permissionIds: [],
      name: '',
      description: '',
      canSeeProtectedFiles: false,
    };
  },
  computed: {
    permissions() {
      return this.$store.getters.getPermissions.map(({ id, title }) => {
        return {
          label: title,
          id: id,
        };
      });
    },
    role() {
      return this.$store.getters.getRole;
    },
    isAllPermissionsChecked() {
      return this.role?.permissions?.length === this.permissions?.length;
    },
    allowedDocumentExtensions() {
      return this.$store.getters.getAllowedDocumentExtensions;
    },
    roleModalText() {
      return this.translations.areYouSureRole.replace(
        "{role}",
        `<strong>${this.role.name}</strong>`
      );
    },
  },
  methods: {
    handleSubmit() {
      api.updateRole(this.role).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'UserRoles' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    checkAllPermissions() {
      if (this.role.permissions.length === this.permissions.length) {
        Vue.nextTick(() => {
          this.role.permissions = [];
        });
      } else {
        Vue.nextTick(() => {
          this.role.permissions = this.permissions.filter((i) => i.id !== 0).map((i) => i.id);
        });
      }
    },
    deleteRole() {
      api
        .deleteRole([this.role.id])
        .then((response) => {
          $('#delete-modal').modal('hide');
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'UserRoles' });
        })
        .catch((err) => {
          $('#delete-modal').modal('hide');
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
  mounted() {
    this.$store.dispatch('getPermissions');
    this.$store.dispatch('getAllowedDocumentExtensions');
    this.$store.dispatch('getRole', parseInt(this.$route.params.id, 10));
  },
};
</script>

<style lang="scss" scoped>
.checkbox-permission {
  --checked-permission-bg: #2b90d9;

  padding: 0.75rem;
  margin-bottom: 0;

  input[type="checkbox"] {
    margin: 1rem;

    &:checked {
      + label:after {
        left: 12px;
        color: #fff;
      }

      + label:before {
        border: 2px solid var(--checked-permission-bg);
        border-radius: 2px;
        background: var(--checked-permission-bg);
        color: #fff;
        margin-top: -9px;
        overflow: hidden;
        height: 19px;
        font-size: 12px;
      }
    }
  }

  label {
    display: block;
    padding-inline: 1.5rem;

    &:before {
      margin-left: 0.5rem;
    }
  }
}
.all-permissions {
  background: #eee;
}

.permissions-wrapper {
  max-height: calc(100vh - 550px);
  overflow: auto;
  border: 1px solid #eee;
}

section {
  height: calc(100vh - 200px);
}
</style>